import { useMemo } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NewWcnTable, { DataTableColumn } from '@/components/datatable/NewWcnTable.tsx';
import { UnassignedShop } from '@/services/logicServiceManagementService';

interface LogicServiceUnassignedShopsTableProps {
    unassignedShops: UnassignedShop[];
}

const LogicServiceUnassignedShopsTable = ({ unassignedShops }: LogicServiceUnassignedShopsTableProps) => {
    const { t } = useTranslation();

    const columns: DataTableColumn<UnassignedShop>[] = useMemo(
        () => [
            {
                text: (
                    <span style={{ fontFamily: 'var(--font-family-medium)', fontWeight: 400, letterSpacing: '1.4px' }}>
                        {t('unassignedShops')}
                    </span>
                ),
                value: 'shopName',
                sortable: false,
                render: (row) => <span style={{ fontSize: 12 }}>{row.name}</span>
            }
        ],
        [t]
    );

    return (
        <Box sx={{ mt: 3 }} className="logic-service-table-wrapper logic-service-unassigned-shops">
            <NewWcnTable columns={columns} data={unassignedShops} size="small" noDataMessage={t('noData')} />
        </Box>
    );
};

export default LogicServiceUnassignedShopsTable;
